import { TableAmountCell } from '@root/features/trade/tables/table-cell/table-amount-cell'

import type { CurrencyModel } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  amount: BigNumber
  currency: CurrencyModel | '$'
} & ClassNameProps

export const OrdersTableAmountCell: React.FC<Props> = ({
  className,
  currency,
  amount,
}) => {
  return (
    <TableAmountCell
      amount={amount}
      className={className}
      currency={currency}
    />
  )
}
